import React, { useState } from 'react';
import {

  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Grow,
} from '@mui/material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import './Contact.css';
import Lottie from 'lottie-react';
import loadingAnimation from './LNzz2M7SoM.json';
import successAnimation from './ATv38NyvuQ.json';



import Particles from './Particles';
const timeSlots = [
  'Any Time',
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
];

const Contact = () => {
  const [date, setDate] = useState(() => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    return today.toISOString().split('T')[0];
  });

  const [selectedSlot, setSelectedSlot] = useState('Any Time');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [formValues, setFormValues] = useState({
    name: '',
    businessName: '',
    email: '',
    phoneNumber: '',
    meetingType: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    businessName: '',
    email: '',
    phoneNumber: '',
    meetingType: '',
  });

  const handleClose = () => {
    setFormValues({
      name: '',
      businessName: '',
      email: '',
      phoneNumber: '',
      meetingType: '',
    });
    setSelectedSlot('Any Time');
    setErrors({});
    setOpen(false);
  };

  const textFieldFontProps = {
    inputProps: { style: { fontFamily: 'Regular' } },
    InputLabelProps: { style: { fontFamily: 'Regular' } },
  };

  const buttonStyle = {
    fontFamily: 'Medium',
    height: '100%',
    fontSize: '12px',
    backgroundColor: '#86BBD8',
    color: '#fff',
  };
  const nonButtonStyle = {
    fontFamily: 'Medium',
    height: '100%',
    fontSize: '12px',
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!formValues.name) {
      formErrors.name = 'Name is required';
      isValid = false;
    }

    if (!formValues.businessName) {
      formErrors.businessName = 'Business Name is required';
      isValid = false;
    }

    if (!formValues.email) {
      formErrors.email = 'Email is required';
      isValid = false;
    } else if (!formValues.email.includes('@')) {
      formErrors.email = 'Email must include an "@" symbol';
      isValid = false;
    }

    if (!formValues.phoneNumber) {
      formErrors.phoneNumber = 'Phone Number is required';
      isValid = false;
    }

    if (formValues.phoneNumber.length < 10) {
      formErrors.phoneNumber = 'Please enter a valid phone number';
      isValid = false;
    }

    if (!formValues.meetingType) {
      formErrors.meetingType = 'Meeting Type is required';
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const isFormValid = () => {
    return (
      formValues.name &&
      formValues.businessName &&
      formValues.email &&
      formValues.email.includes('@') &&
      formValues.phoneNumber &&
      formValues.phoneNumber.length >= 10 &&
      formValues.meetingType
    );
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);

      const emailData = {
        name: formValues.name,
        businessName: formValues.businessName,
        email: formValues.email,
        phoneNumber: formValues.phoneNumber,
        meetingType: formValues.meetingType,
        preferredDate: date,
        selectedSlot,
      };

      try {
        const response = await fetch(
          'https://sendcontactemail-4yg476kfiq-uc.a.run.app',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(emailData),
          }
        );
        
        const data = await response.json();
        
        if (response.ok) {
          console.log('Email successfully sent:', data);
          setSuccessMessage('Your meeting request has been successfully submitted!');
        } else {
          console.error('Failed to send email:', data);
          setSuccessMessage('Failed to send email. Please try again later.');
        }
      } catch (error) {
        console.error('Failed to send email:', error);
        setSuccessMessage('Failed to send email. Please try again later.');
      } finally {
        setTimeout(() => {
          setLoading(false);
          setOpen(true);
        }, 1250);
      }
    }
  };

  return (
    <div
      className="contactContainer"
      style={{
        width: '100vw',
        minHeight: '100vh',
        position: 'relative',
        margin: 0,
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden', // Prevent scrollbars from ripple overflow
      }}
    >
      {/* Ripple background - covers entire contact container */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      >










        <Particles
          particleColors={['#86BBD8', '#9EE493']}
          particleCount={500}
          particleSpread={12}
          speed={0.05}
          particleBaseSize={150}
          moveParticlesOnHover={true}
          alphaParticles={false}
          disableRotation={false}
        />


      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Grow}
        transitionDuration={500}
      >
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Lottie
              animationData={successAnimation}
              loop={false}
              style={{ maxWidth: '130px', marginBottom: '10px' }}
            />
            <div
              style={{
                marginTop: '10px',
                color: 'black',
                fontFamily: 'Medium',
                fontSize: '1.2rem',
                textAlign: 'center',
                marginLeft: '10%',
                marginRight: '10%',
              }}
            >
              Form submitted successfully! Be on the lookout for an email from our team!
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {loading && (
        <div className="loadingOverlay">
          <Lottie
            animationData={loadingAnimation}
            loop={true}
            style={{ width: '95%', height: '95%' }}
          />
        </div>
      )}

      {/* Form content - positioned above ripple background */}
      <div className="formCard">

        {/* <div className="title" style={{ color: '#336699' }}>Book a free introductory meeting</div>
        <div className="subTitle" style={{ color: '#336699' }}> */}
        <div
          style={{
            backgroundColor: '#336699',
            color: 'white',
            padding: '0px',
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px',
            textAlign: 'center',
            fontFamily: 'Regular',
          }}
        >
          <div style={{ padding: '12px 16px' }}>
            <div className="title" style={{ color: 'white', }}>
              Book a free introductory meeting
            </div>
            <div
              className="subTitle"
              style={{ color: 'white', marginTop: '4px', }}
            >
              Interested in hearing what we can do for your business? Set up a free
              meeting with our team!
            </div>
          </div>
        </div>



        <form className="contactForm" onSubmit={handleSubmit}>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            name="name"
            value={formValues.name}
            onChange={handleInputChange}
            error={!!errors.name}
            helperText={errors.name}
            {...textFieldFontProps}
          />

          <TextField
            label="Business Name"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            name="businessName"
            value={formValues.businessName}
            onChange={handleInputChange}
            error={!!errors.businessName}
            helperText={errors.businessName}
            {...textFieldFontProps}
          />

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            name="email"
            type="email"
            value={formValues.email}
            onChange={handleInputChange}
            error={!!errors.email}
            helperText={errors.email}
            {...textFieldFontProps}
          />

          <TextField
            label="Phone Number"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            name="phoneNumber"
            type="tel"
            value={formValues.phoneNumber}
            onChange={handleInputChange}
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
            inputProps={{
              pattern: "^[+]?[0-9]{1,4}?[-.\\s]?[0-9]+[-.\\s]?[0-9]+[-.\\s]?[0-9]+$",
              style: { fontFamily: 'Regular' },
            }}
            {...textFieldFontProps}
          />

          <FormControl fullWidth margin="normal" error={!!errors.meetingType}>
            <InputLabel
              id="consultation-type-label"
              style={{ fontFamily: 'Regular' }}
            >
              Meeting Type*
            </InputLabel>
            <Select
              labelId="consultation-type-label"
              label="Consultation Type"
              name="meetingType"
              value={formValues.meetingType}
              onChange={handleInputChange}
              inputProps={{ style: { fontFamily: 'Regular' } }}
            >
              <MenuItem value="needs" style={{ fontFamily: 'Regular' }}>
                General Introduction
              </MenuItem>
              <MenuItem value="website" style={{ fontFamily: 'Regular' }}>
                Website Creation
              </MenuItem>
              <MenuItem value="options" style={{ fontFamily: 'Regular' }}>
                Explore Pricing Plans
              </MenuItem>

              <MenuItem value="deployment" style={{ fontFamily: 'Regular' }}>
                Explain Deployment Process
              </MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Preferred Date"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
              style: { fontFamily: 'Regular' },
            }}
            InputProps={{
              sx: {
                minHeight: 48, // Works well on both mobile and desktop
              },
            }}
            inputProps={{
              style: { fontFamily: 'Regular' },
            }}
          />



          <div className="timeSlotContainer" style={{ fontFamily: 'Regular' }}>
            <p
              style={{
                fontFamily: 'Medium',
                textAlign: 'center',
                marginLeft: '10%',
                marginRight: '10%',
                fontSize: '1.1rem',
              }}
            >
              Select a preferred 30 minute time slot
            </p>

            <Grid container spacing={2}>
              {timeSlots.map((slot, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  <Button
                    variant={selectedSlot === slot ? 'contained' : 'outlined'}
                    onClick={() => setSelectedSlot(slot)}
                    fullWidth
                    style={selectedSlot === slot ? buttonStyle : nonButtonStyle}
                  >
                    {slot}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </div>

          <Button
            type="submit"
            variant="contained"
            disabled={loading || !isFormValid()}
            style={{
              fontFamily: 'Medium',
              height: '100%',
              fontSize: '1rem',
              backgroundColor: (loading || !isFormValid()) ? '#cccccc' : '#336699',
              marginBottom: '30px',
              color: 'white',
              position: 'relative',
            }}
            onClick={handleSubmit}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Contact;